import { Box, Button, Flex, Heading, Image, Text, Alert, AlertIcon } from "@chakra-ui/react";
import successIcon from "../assets/success.svg";

/**
 * @param {object} props
 * @param {() => void} props.onClose
 * @param {{ onboarding_documents_saved?: number, ess_provisioned?: boolean, ess_notice?: string | null } | null} [props.summary] — create-employee API extras (add flow only)
 */
const EmployeeSuccess = ({ onClose, summary = null }) => {
  const docsSaved = summary?.onboarding_documents_saved ?? 0;
  const essProv = !!summary?.ess_provisioned;
  const essNotice = summary?.ess_notice;
  const emailLikelyFailed =
    essProv &&
    essNotice &&
    typeof essNotice === "string" &&
    /fail|error|smtp|not\s+sent|could\s+not|unable\s+to\s+send/i.test(essNotice);

  return (
    <Flex
      bg="#fff"
      maxW="400px"
      flexDirection="column"
      p="1rem"
      borderRadius="20px"
      boxShadow="rgba(151, 146, 146, 0.15) 5.4px 5.4px 6.2px"
      position="relative"
      onClick={(e) => e.stopPropagation()}
    >
      <Box mt="5rem">
        <Image
          src={successIcon}
          alt="Employee uploaded successfully icon"
          mx="auto"
        />
      </Box>
      <Heading textAlign={"center"} as="h2" mt={5} fontSize={["18px", "28px"]} mb="1rem">
        Employee created successfully.
      </Heading>

      {docsSaved > 0 && (
        <Text textAlign="center" fontSize="sm" color="gray.600" mb={2}>
          {docsSaved} onboarding document{docsSaved === 1 ? "" : "s"} saved.
        </Text>
      )}

      {essProv && (
        <Text textAlign="center" fontSize="sm" color="gray.600" mb={2}>
          Employee self-service login was provisioned. They should receive a welcome email with a temporary password.
        </Text>
      )}

      {emailLikelyFailed && (
        <Alert status="warning" borderRadius="md" fontSize="sm" mb={3}>
          <AlertIcon />
          <Box>
            <Text fontWeight="600">Email may not have been delivered</Text>
            <Text mt={1}>{essNotice}</Text>
            <Text mt={1} fontSize="xs" color="gray.700">
              The account may still exist; use password reset if they cannot sign in.
            </Text>
          </Box>
        </Alert>
      )}

      <Button mt={5} onClick={onClose}>
        Done
      </Button>
    </Flex>
  );
};

export default EmployeeSuccess;
